import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import axios from "../../API/axios";
import SortBuy from "../../components/dropdown/SortBuy";
import { ShimmerDiv } from "shimmer-effects-react";
import { Row } from "react-bootstrap";
import CompanyImg from "../../assets/images/khoj-images/image 484.png";
import error from "../../assets/images/No-File-small.png";
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import WcOutlinedIcon from '@mui/icons-material/WcOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';

const PplSearch = () => {
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [userList, setUserList] = useState([]);
  const [searchuserList, setSearchuserList] = useState([]);
  const [searchUserName, setSearchUserName] = useState("");

  const [isError, setIsError] = useState(false);
  const [reset, setReset] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [nextBatchLoading, setNextBatchLoading] = useState("");

  const getAllUserList = (page) => {
    setNextBatchLoading(true);
    const data = {
      pageNumber: page,
      pageSize: 20,
    };

    axios
      .post(`/Candidate/GetAll?Search=${searchUserName}`, data)
      .then((response) => {
        const res = response.data.responseData.candidateProfiles; 
        setUserList(res);
        setIsLoading(false);
        setTotalPages(response.data.responseData.paging.totalPages);

        const newPosts = response.data.responseData.candidateProfiles;
        console.log("newwwwposttt", newPosts);

        if (searchUserName !== "") {
          setUserList([]);
          setSearchuserList(newPosts);
        } else {
          setSearchuserList([]);
          setUserList((prev) => {
            const userSet = new Set(prev?.map((user) => user?.uid));
            const uniqueNewPosts = newPosts.filter(
              (user) => !userSet.has(user?.uid)
            );
            return [...prev, ...uniqueNewPosts];
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setIsError(true);
        } else {
          console.log(error);
        }
        setIsLoading(false);
        setNextBatchLoading(false);
      });
  };
  // useEffect(() => {
  //   if (page <= totalPages) {
  //     getAllUserList(page + 1);
  //   }
  // }, [page]);

  // useEffect(() => {
  //   setUserList([]);
  //   getAllUserList(1, searchUserName);
  // }, [searchUserName]);
  useEffect(() => {
    if (page <= totalPages) {
      getAllUserList(page + 1);
    }

    if (searchUserName) {
      setUserList([]);
      getAllUserList(1, searchUserName);
    }
  }, [page, searchUserName]);

  const handleInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setLoading(true);
        console.log("log", page, totalPages);

        page < totalPages && setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, []);

  return (
    <>
      <section className="inner-employer-section PeopleSearch pt-5">
        <div className="container">
          <div className="row">
            <Tabs className="col-lg-12 tf-tab">
              <Row>
                <div className="wd-meta-select-job">
                  <div className="wd-findjob-filer">
                    <div className="group-select-display"></div>
                    <div className="form-group-1 ">
                      <input
                        type="email"
                        className="form-control p-2 Dark-Input-from-group"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        placeholder="Search User "
                        onChange={(e) => {
                          setSearchUserName(e.target.value);
                          getAllUserList();
                        }}
                        value={searchUserName}
                      />
                    </div>
                  </div>
                </div>
              </Row>
              <Row>
                <div className="container ">
                  <div className=" content-tab">
                    <TabPanel
                      className="inner"
                      style={{
                        minHeight:
                          isLoading || nextBatchLoading ? "600px" : "auto",
                        height: "auto",
                      }}
                    >
                      <div className="group-col-3 Candidate-Profile-Mobile">
                        {isLoading ? (
                          <div className="row mt-2">
                            <div className=" ">
                              <ShimmerDiv
                                mode="light"
                                height={400}
                                width={"100%"}
                              />
                            </div>
                            <div className="col-md-6">
                              <ShimmerDiv
                                mode="light"
                                height={400}
                                width={"100%"}
                              />
                            </div>
                            <div className="col-md-6 mt-2">
                              <ShimmerDiv
                                mode="light"
                                height={400}
                                width={"100%"}
                              />
                            </div>
                            <div className="col-md-6 mt-2">
                              <ShimmerDiv
                                mode="light"
                                height={400}
                                width={"100%"}
                              />
                            </div>
                            <div className="col-md-6 mt-2">
                              <ShimmerDiv
                                mode="light"
                                height={400}
                                width={"100%"}
                              />
                            </div>
                            <div className="col-md-6 mt-2">
                              <ShimmerDiv
                                mode="light"
                                height={400}
                                width={"100%"}
                              />
                            </div>
                          </div>
                        ) : isError ||
                          (userList.length === 0 &&
                            searchuserList.length === 0) ? (
                          <div className="mt-2 error-image-cont error-cont m-auto">
                            <img src={error} alt="404 Not Found" width={300} />
                          </div>
                        ) : searchuserList.length === 0 ? (
                          userList &&
                          userList?.map((user, index) => {
                            return (
                              <div
                                key={index}
                                class="features-job feature-candi wd-thum-career stc style-2 cl3 NewCl3 col-md-6"
                              >
                                <div class="job-archive-header">
                                  <div class="career-header-left">
                                    <img
                                      src={user.profileImage}
                                      alt="jobtex"
                                      class="thumb"
                                    />
                                    <div class="career-left-inner">
                                      {token === null ? (
                                        <div>
                                          <h4 className="p-0">
                                            {user.firstName} {user.lastName}
                                          </h4>
                                        </div>
                                      ) : (
                                        <h4 className="p-0">
                                          <Link to={`/User/${user.cnddtUID}`}>
                                            {user.firstName} {user.lastName}
                                          </Link>
                                        </h4>
                                      )}
                                      <ul class="career-info candidate-profile mt-0">
                                        {
                                          user.cityName === null ? (
                                            ""
                                          ) : ( 
                                            <>
                                            <li className="align-center"> 
                                            <CalendarMonthSharpIcon className="me-1 mb-0 f-18"/>
                                              {user.dob}</li>
                                            </>
                                          ) 
                                        }
                                      </ul>
                                      <ul class="career-tag p-0">
                                        {user.genderName === null ? (
                                          ""
                                        ) : (
                                          <li>
                                            <>
                                            <Link to="#">
                                            <span>

                                            <WcOutlinedIcon className="me-1 f-18" />
                                            </span>
                                              {user.genderName}
                                            </Link>
                                            </>
                                          </li>
                                        )}
                                        {user.langName === null ? (
                                          ""
                                        ) : (
                                          <li className="align-center">
                                            <>
                                            <Link to="#">
                                            <LanguageOutlinedIcon className="me-1 f-18"/>
                                           <span className="mt-1">
                                            {user.langName}
                                            </span> 
                                            </Link>
                                            </>
                                          </li>
                                        )}
                                        {user.cityName === null ? (
                                          ""
                                        ) : (
                                          <li>
                                            <Link to="#">
                                              <span class="icon-map-pin me-1"></span>
                                              {user.cityName}
                                            </Link>
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div class="job-archive-footer">
                                  {token === null ? (
                                    <Link
                                      to="#/"
                                      class="tf-btn View-profile-Btn "
                                    >
                                      View Profile
                                    </Link>
                                  ) : (
                                    <Link
                                      to={`/User/${user.cnddtUID}`}
                                      class="tf-btn View-profile-Btn disabled-btn"
                                    >
                                      View Profile
                                    </Link>
                                  )}
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          searchuserList &&
                          searchuserList?.map((user, index) => {
                            return (
                              <div
                                key={index}
                                class="features-job feature-candi wd-thum-career stc style-2 cl3 NewCl3 col-md-6"
                              >
                                <div class="job-archive-header">
                                  <div class="career-header-left">
                                    <img
                                      src={user.profileImage}
                                      alt="jobtex"
                                      class="thumb"
                                    />
                                    <div class="career-left-inner">
                                      {token === null ? (
                                        <div>
                                          <h4 className="p-0">
                                            {user.firstName} {user.lastName}
                                          </h4>
                                        </div>
                                      ) : (
                                        <h4 className="p-0">
                                          <Link to={`/User/${user.cnddtUID}`}>
                                            {user.firstName} {user.lastName}
                                          </Link>
                                        </h4>
                                      )}
                                      <ul class="career-info candidate-profile mt-0">
                                        {
                                          user.cityName === null ? (
                                            ""
                                          ) : ( 
                                            <>
                                            <li className="align-center"> 
                                            <CalendarMonthSharpIcon className="me-1 mb-0 f-18 d-inline "/>
                                              {user.dob}</li>
                                            </>
                                          ) 
                                        }
                                      </ul>
                                      <ul class="career-tag">
                                        {user.genderName === null ? (
                                          ""
                                        ) : (
                                          <li>
                                            <>
                                            <Link to="#">
                                            <span>

                                            <WcOutlinedIcon className="me-1 f-18 d-inline " />
                                            </span>
                                              {user.genderName}
                                            </Link>
                                            </>
                                          </li>
                                        )}
                                        {user.langName === null ? (
                                          ""
                                        ) : (
                                          <li className="align-center">
                                            <>
                                            <Link to="#">
                                            <LanguageOutlinedIcon className="me-1 f-18 d-inline "/>
                                           <span className="mt-1">
                                            {user.langName}
                                            </span> 
                                            </Link>
                                            </>
                                          </li>
                                        )}
                                        {user.cityName === null ? (
                                          ""
                                        ) : (
                                          <li>
                                            <Link to="#">
                                              <span class="icon-map-pin me-1"></span>
                                              {user.cityName}
                                            </Link>
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div class="job-archive-footer">
                                  {token === null ? (
                                    <Link
                                      to="#/"
                                      class="tf-btn View-profile-Btn "
                                    >
                                      View Profile
                                    </Link>
                                  ) : (
                                    <Link
                                      to={`/User/${user.cnddtUID}`}
                                      class="tf-btn View-profile-Btn disabled-btn"
                                    >
                                      View Profile
                                    </Link>
                                  )}
                                </div>
                              </div>
                            );
                          })
                        )}
                        {nextBatchLoading && (
                          <div className="text-center">
                            {/* <img src={post?.loader} width={50} /> */}
                          </div>
                        )}
                      </div>
                    </TabPanel>
                  </div>
                </div>
              </Row>
            </Tabs>
          </div>
        </div>
      </section>
    </>
  );
};

export default PplSearch;
